import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-white">
      <div className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-18">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-[40%]">
            <h2 className="font-heading text-2xl md:text-3xl mb-4">
              订阅我们的<br />最新爆料
            </h2>
            <p className="text-primary-200/80 text-sm leading-relaxed mb-6 max-w-md">
              不想错过任何大瓜？订阅911爆料网邮件通知，最新网红黑料、明星八卦第一时间送达你的邮箱。
            </p>
            <form
              className="flex flex-col sm:flex-row gap-3 max-w-md"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="flex-1">
                <label className="sr-only" htmlFor="footer-email">邮箱地址</label>
                <input
                  id="footer-email"
                  type="email"
                  name="email"
                  placeholder="输入你的邮箱地址"
                  className="w-full bg-transparent border-b border-primary-500/50 px-2 py-3 text-sm text-white placeholder:text-primary-300/60 focus:outline-none focus:border-white transition-colors"
                />
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="website-alt-field"
                />
              </div>
              <button
                type="submit"
                className="px-6 py-3 border border-primary-500/60 text-white text-sm font-medium rounded-lg hover:bg-primary-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                订阅
              </button>
            </form>
          </div>

          <div className="lg:w-[60%] grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="font-medium text-sm mb-4 text-white/90">
                <Link to="/about" className="hover:text-white transition-colors">关于我们</Link>
              </h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/about" className="text-sm text-primary-200/70 hover:text-white transition-colors">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-primary-200/70 hover:text-white transition-colors">
                    联系方式
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-primary-200/70 hover:text-white transition-colors">
                    加入我们
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-medium text-sm mb-4 text-white/90">热门分类</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/category/wanghong-heiliao" className="text-sm text-primary-200/70 hover:text-white transition-colors">
                    网红黑料
                  </Link>
                </li>
                <li>
                  <Link to="/category/mingxing-bagua" className="text-sm text-primary-200/70 hover:text-white transition-colors">
                    明星八卦
                  </Link>
                </li>
                <li>
                  <Link to="/category/shehui-redian" className="text-sm text-primary-200/70 hover:text-white transition-colors">
                    社会热点
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-medium text-sm mb-4 text-white/90">法律声明</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/privacy" className="text-sm text-primary-200/70 hover:text-white transition-colors">
                    隐私政策
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="text-sm text-primary-200/70 hover:text-white transition-colors">
                    用户协议
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-primary-200/70 hover:text-white transition-colors" rel="nofollow">
                    侵权投诉
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-primary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-primary-300/70">
            &copy; {new Date().getFullYear()} 911爆料网 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full text-primary-300/70 hover:text-white transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full text-primary-300/70 hover:text-white transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full text-primary-300/70 hover:text-white transition-colors cursor-pointer" aria-label="抖音" rel="nofollow">
              <i className="ri-tiktok-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}